export default {
  // Hero Section
  'hero.title': 'The Future of Sports is Digital',
  'hero.subtitle': 'We are revolutionizing the sports industry through innovative digital solutions that connect athletes, fans, and brands in entirely new ways.',
  'hero.cta': 'Join Now',
  'hero.learnMore': 'Learn More',
  
  // The Idea
  'idea.title': 'The Idea',
  'idea.subtitle': 'A vision that will change sports forever',
  'idea.description': 'Imagine a world where every fan has direct access to their favorite athletes. Where digital technologies not only change how we consume sports, but also how athletes interact with their community and benefit from it.',
  'idea.point1Title': 'Direct Connection',
  'idea.point1Desc': 'Fans can communicate directly with their idols and receive exclusive content',
  'idea.point2Title': 'New Revenue Streams',
  'idea.point2Desc': 'Athletes unlock innovative monetization opportunities beyond traditional sponsorship deals',
  'idea.point3Title': 'Community-Driven',
  'idea.point3Desc': 'A vibrant community that grows together and benefits from success',
  'idea.exampleTitle': 'Want a concrete example?',
  'idea.exampleDesc': 'Discover a project that already has over 1 million active users and whose token valuation could rise above $100.',
  'idea.exampleCta': 'View Success Story',
  
  // Fan Economy
  'fanEconomy.title': 'The Fan Economy',
  'fanEconomy.subtitle': 'When passion meets innovation',
  'fanEconomy.intro': 'The sports industry is facing a paradigm shift. Fans want more than just being spectators – they want to be part of the story.',
  'fanEconomy.stat1': 'Billion',
  'fanEconomy.stat1Label': 'Global Sports Fans',
  'fanEconomy.stat2': 'Billion $',
  'fanEconomy.stat2Label': 'Market Volume',
  'fanEconomy.stat3': '%',
  'fanEconomy.stat3Label': 'Annual Growth',
  'fanEconomy.trend1Title': 'Digital Transformation',
  'fanEconomy.trend1Desc': 'Sports are becoming increasingly digital – from NFTs to virtual experiences',
  'fanEconomy.trend2Title': 'Direct-to-Fan',
  'fanEconomy.trend2Desc': 'Athletes build direct relationships with their fans, without intermediaries',
  'fanEconomy.trend3Title': 'Tokenization',
  'fanEconomy.trend3Desc': 'Fans can invest in their favorite athletes and participate in their success',
  
  // Digital Giants
  'giants.title': 'The Digital Giants',
  'giants.subtitle': 'Success stories that pave the way',
  'giants.intro': 'Major platforms have already proven that connecting sports, community, and digital assets works:',
  'giants.socios.title': 'Socios.com',
  'giants.socios.desc': 'The world\'s leading platform for fan tokens has over 2 million users and partnerships with top clubs like FC Barcelona, PSG, and Juventus Turin.',
  'giants.socios.stat1': '2M+',
  'giants.socios.stat1Label': 'Active Users',
  'giants.socios.stat2': '100+',
  'giants.socios.stat2Label': 'Partner Clubs',
  'giants.socios.stat3': '$400M+',
  'giants.socios.stat3Label': 'Trading Volume',
  'giants.sorare.title': 'Sorare',
  'giants.sorare.desc': 'The fantasy football game with NFT cards has revolutionized the industry and achieved a valuation of over 4 billion dollars.',
  'giants.sorare.stat1': '5M+',
  'giants.sorare.stat1Label': 'Registered Users',
  'giants.sorare.stat2': '300+',
  'giants.sorare.stat2Label': 'Licensed Leagues',
  'giants.sorare.stat3': '$4.3B',
  'giants.sorare.stat3Label': 'Company Value',
  'giants.nba.title': 'NBA Top Shot',
  'giants.nba.desc': 'The official NBA platform for digital collectibles has thrilled millions of fans and generated over 1 billion dollars in revenue.',
  'giants.nba.stat1': '1M+',
  'giants.nba.stat1Label': 'Collectors',
  'giants.nba.stat2': '$1B+',
  'giants.nba.stat2Label': 'Total Revenue',
  'giants.nba.stat3': '20M+',
  'giants.nba.stat3Label': 'NFTs Sold',
  
  // Digital Revolution
  'revolution.title': 'The Digital Revolution in Sports',
  'revolution.subtitle': 'Why now is the perfect time',
  'revolution.reason1Title': 'Technology is Ready',
  'revolution.reason1Desc': 'Blockchain, NFTs, and digital wallets have matured and become mainstream',
  'revolution.reason2Title': 'Fans Demand More',
  'revolution.reason2Desc': 'The new generation wants participation, interaction, and real value',
  'revolution.reason3Title': 'Athletes Seek Alternatives',
  'revolution.reason3Desc': 'Traditional sponsorship models are no longer sufficient',
  'revolution.reason4Title': 'Brands are Investing',
  'revolution.reason4Desc': 'Major brands recognize the potential and invest billions',
  'revolution.quote': 'The future of sports lies in the direct connection between athletes and fans. Those who don\'t act now will miss the biggest opportunity of the last decade.',
  'revolution.quoteAuthor': 'Sports Industry Analyst',
  
  // Target Groups
  'target.title': 'Who is this for?',
  'target.subtitle': 'Different perspectives, one common goal',
  'target.athletes.title': 'Athletes & Sports Professionals',
  'target.athletes.benefit1': 'Unlock new revenue streams',
  'target.athletes.benefit2': 'Direct connection to fan community',
  'target.athletes.benefit3': 'Independence from traditional sponsors',
  'target.athletes.benefit4': 'Long-term wealth building',
  'target.investors.title': 'Investors & Entrepreneurs',
  'target.investors.benefit1': 'Access to a billion-dollar market',
  'target.investors.benefit2': 'Early participation in innovation',
  'target.investors.benefit3': 'Portfolio diversification',
  'target.investors.benefit4': 'Exponential growth potential',
  'target.brands.title': 'Brands & Sponsors',
  'target.brands.benefit1': 'Authentic target audience engagement',
  'target.brands.benefit2': 'Measurable marketing success',
  'target.brands.benefit3': 'Innovative cooperation models',
  'target.brands.benefit4': 'Access to engaged communities',
  'target.creators.title': 'Creators & Influencers',
  'target.creators.benefit1': 'Monetize your reach',
  'target.creators.benefit2': 'Exclusive content opportunities',
  'target.creators.benefit3': 'Community building tools',
  'target.creators.benefit4': 'Passive income streams',
  
  // Exclusive Access
  'exclusive.title': 'Exclusive Access',
  'exclusive.subtitle': 'Be part of the digital sports revolution',
  'exclusive.description': 'We are looking for selected partners, investors, and visionaries who want to shape the future of sports with us. Places are limited.',
  'exclusive.feature1Title': 'Early Access',
  'exclusive.feature1Desc': 'Be the first to access new projects and opportunities',
  'exclusive.feature2Title': 'Exclusive Insights',
  'exclusive.feature2Desc': 'Detailed analyses, market data, and insider information',
  'exclusive.feature3Title': 'Personal Consultation',
  'exclusive.feature3Desc': 'Direct contact with our team and individual onboarding',
  'exclusive.feature4Title': 'Network',
  'exclusive.feature4Desc': 'Access to an exclusive network of like-minded individuals',
  'exclusive.cta': 'Register Now',
  'exclusive.ctaSecondary': 'Discover the Project',
  'exclusive.limited': 'Only a few spots left',
  
  // Lead Form
  'form.title': 'Request',
  'form.titleHighlight': 'Information',
  'form.titleEnd': 'Now',
  'form.name': 'Name',
  'form.namePlaceholder': 'Your full name',
  'form.email': 'Email',
  'form.emailPlaceholder': 'your@email.com',
  'form.country': 'Country',
  'form.countryPlaceholder': 'United States',
  'form.role': 'Role',
  'form.rolePlaceholder': 'Please select...',
  'form.roleAthlete': 'Player / Athlete',
  'form.roleAgent': 'Agent / Advisor',
  'form.roleInvestor': 'Entrepreneur / Investor',
  'form.roleBrand': 'Brand / Sponsor',
  'form.roleCreator': 'Creator / Influencer',
  'form.roleOther': 'Other',
  'form.interest': 'What interests you about digitalization in sports?',
  'form.interestPlaceholder': 'Tell us about your interests and goals...',
  'form.privacy': 'I have read the',
  'form.privacyLink': 'Privacy Policy',
  'form.privacyText': 'and agree that my information will be stored permanently for contact and follow-up purposes.',
  'form.submit': 'Send Request',
  'form.submitting': 'Sending...',
  'form.disclaimer': 'We review each request individually and will contact you personally',
  'form.disclaimerLine2': 'if your profile matches the current project.',
  'form.required': '*',
  'form.charCount': 'characters',
  
  // Thank You
  'thanks.title': 'Thank You!',
  'thanks.subtitle': 'Your request has been successfully submitted',
  'thanks.message': 'We have received your information and will contact you shortly. Please also check your spam folder.',
  'thanks.nextSteps': 'Next Steps:',
  'thanks.step1': 'We review your profile',
  'thanks.step2': 'You receive a personal response',
  'thanks.step3': 'If interested, we schedule a call',
  'thanks.backHome': 'Back to Home',
};